export const PROCESS_INFORMATION = [
    {
        imgSrc: 'assets/matchmaking/icon-clipboard-text.svg',
        translationTitleKey: 'processInfoStatement1',
        translationDescriptionKey: 'processInfoStatement1Description'
    },
    {
        imgSrc: 'assets/matchmaking/icon-sliders-vertical.svg',
        translationTitleKey: 'processInfoStatement2',
        translationDescriptionKey: 'processInfoStatement2Description'
    },
    {
        imgSrc: 'assets/matchmaking/icon-chats.svg',
        translationTitleKey: 'processInfoStatement3',
        translationDescriptionKey: 'processInfoStatement3Description'
    }
];

export const KEY_BENEFITS = [
    {
        imgSrc: 'assets/matchmaking/icon-chart-line-up.svg',
        translationTitleKey: 'keyBenefitsTitle1',
        translationDescriptionKey: 'keyBenefitsDescription1'
    },
    {
        imgSrc: 'assets/matchmaking/icon-target.svg',
        translationTitleKey: 'keyBenefitsTitle2',
        translationDescriptionKey: 'keyBenefitsDescription2'
    },
    {
        imgSrc: 'assets/matchmaking/icon-shield-check.svg',
        translationTitleKey: 'keyBenefitsTitle3',
        translationDescriptionKey: 'keyBenefitsDescription3'
    },
    {
        imgSrc: 'assets/matchmaking/icon-currency-dollar-simple.svg',
        translationTitleKey: 'keyBenefitsTitle4',
        translationDescriptionKey: 'keyBenefitsDescription4'
    }
];
